import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export interface SaveOnboardingArgs {
  userId: string;
  yardId: string;
  role?: string | null;
  postcode?: string | null;
  primaryFocus?: string | null;
}

export async function saveOnboarding({
  userId,
  yardId,
  role,
  postcode,
  primaryFocus,
}: SaveOnboardingArgs): Promise<void> {
  const userRef = doc(db, "users", userId);
  const yardRef = doc(db, "yards", yardId);
  await Promise.all([
    updateDoc(userRef, {
      role: role || null,
      onboarded: true,
    }),
    updateDoc(yardRef, {
      postcode: postcode ? postcode.trim().toUpperCase() : null,
      primaryFocus: primaryFocus || null,
    }),
  ]);
}
